
import React from 'react'

interface EmptyStateProps {
  title: string
  message: string
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message }) => {
  return (
    <div className="text-center py-8">
      <p className="text-gray-500 text-sm">{message}</p>
    </div>
  )
}

export default EmptyState
